<template>
    <Paper header="Events">
        <BaseButton
            slot="header"
            variant="outline-secondary"
            tiny
            @click="hideExpired = !hideExpired"
        >
            <span v-if="hideExpired">Show completed</span> <span v-else>Hide completed</span>
        </BaseButton>
        <div v-if="value.length" class="p-4">
            <div v-if="listMode">
                <div v-for="event in filteredEvents" :key="event.id">
                    <Event class="mb-2" :value="event" :vFairId="vFairId"></Event>
                </div>
            </div>
            <div v-else class="row">
                <div v-for="event in filteredEvents" :key="event.id" class="col-md-6">
                    <Event class="mb-2" :value="event" :vFairId="vFairId"></Event>
                </div>
            </div>
        </div>
        <div v-else>
            <p style="padding:15px">No events available</p>
        </div>
    </Paper>
</template>

<script>
import Event from './Event';
import moment from 'moment';

export default {
    name: 'EventList',
    components: { Event },
    data() {
        return {
            hideExpired: true,
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        listMode: {
            type: Boolean,
            default: true,
        },
        vFairId: {
            type: String,
            default: '',
            required: true,
        },
    },
    methods: {
        hasExpired(event) {
            const end = new moment(event.endTime);
            return moment().isAfter(end);
        },
    },
    computed: {
        filteredEvents() {
            if (this.hideExpired) {
                return this.value.filter(event => !this.hasExpired(event));
            } else {
                return this.value;
            }
        },
    },
};
</script>

<style scoped></style>
